<template>
  <b-row v-if="parentPath && path">
    <b-col md="12">
      <b-card
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <!-- :header="uniTranslation('S446')"  -->
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor
                :parent-path="path"
                :name="'.totalCapacity'"
                :show-input="!modalitaSimulation ? 1 : 0"
                :show-output2="1"
                :override-input-class="undefined"
                :override-output2-class="modalitaSimulation ? 'col-12' : undefined"
                :auto-decimals="4"
              ></UnidataEditor>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor
                :parent-path="path"
                :name="'.globalFactor'"
                :auto-decimals="4"
              ></UnidataEditor>
            </div>
          </div>
        </div>
        <div class="row">
          {{ JSON.stringify(projects[path]) }}
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor
                :parent-path="path"
                :name="'.totalOversizing'"
                :fixed-decimals="2"
                :input-style="projects[parentPath][localPath.substring(1)].totalOversizing.output.usrValue.value != null && projects[parentPath][localPath.substring(1)].totalOversizing.output.usrValue.value < 0 ? 'background-color: #C21E5655' : ''"
              ></UnidataEditor>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor :parent-path="path" :name="'.lmtd'" :auto-decimals="4"></UnidataEditor>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor
                :parent-path="path"
                :name="'.heatTransfertArea'"
                :auto-decimals="2"
              ></UnidataEditor>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12">
            <div>
              <UnidataEditor
                :parent-path="path"
                :name="'.foulingFactor'"
                :auto-decimals="8"
                :min="0"
              ></UnidataEditor>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditor from "../unidata/UnidataEditor";
import { mapGetters } from "vuex";
import colorsService from "../../services/backend/colorsService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    UnidataEditor
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      modalitaSimulation: false,
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      unsubscribes: []
    };
  },
  computed: {
    ...mapGetters(["projects"]),
    mostraDelta: function() {
      return this.$store.getters.status_Selezione;
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    var that = this;

    that.unsubscribes.push(
      that.$store.subscribe(function(mutation) {
        if (mutation.type === "changeProjectProperty") {
          if (mutation.payload.path.startsWith(that.parentPath + ".shoulder.idCalculationType")) {
            if (mutation.payload.value == 3) {
              that.modalitaSimulation = true;
            } else {
              that.modalitaSimulation = false;
            }
          }
        }
      })
    );

    //colorsService.getColoriCard().then(function(colorList) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important";
    that.coloreTesto = colorList[2];
    that.coloreBordo = colorList[6];
    //});
  },
  methods: {}
};
</script>

<style lang="scss"></style>
